"use client"

import { DropsSpotlightStoreMolecule } from "@/app/collections/drops/spotlight/drops-spotlight-store.reatom"
import { getDropHref } from "@/app/navigation/drop"
import { PriceWrapper } from "@/app/price"
import type { MinimalDrop } from "@anaconda/core/drop/types"
import { Trans } from "@lingui/react/macro"
import {
  Button,
  type ButtonProps,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  cn,
} from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { useRouter } from "next/navigation"

type Props = Omit<ButtonProps, "onClick" | "disabled"> & {
  withPrice?: boolean
  drop: MinimalDrop
}

/**
 * Lightweight mint widget for spotlight carousel.
 * Uses DropsSpotlightStoreMolecule which only fetches on slide change.
 * Redirects to the drop page where user can mint.
 */
export const SpotlightMintWidget = reatomComponent<Props>(
  ({ drop, withPrice = true, ...rest }) => {
    const { activeSlide } = useMolecule(DropsSpotlightStoreMolecule)
    const router = useRouter()

    // Read atomized active slide data
    const slide = activeSlide()
    const { currentPhase, displayPrice, hasEnded, isUpcomming } = slide

    const handleClick = () => {
      router.push(getDropHref(drop.id))
    }

    return (
      <Button
        onClick={handleClick}
        {...rest}
        className={cn(
          "mint-button",
          "disabled:pointer-events-auto disabled:hover:transform-none",
        )}
        data-testid="spotlight-mint-button"
      >
        <Trans>Go to mint page</Trans>
      </Button>
    )
  },
  "SpotlightMintWidget",
)
